<template>
    <unicom-modal v-model="mostrar" :largura="720" fechar @input="fecharModal" class="modal">
        <div slot="header">
            <h3 class="fonte-primaria titulo negrito">Remoção de papéis</h3>
        </div>

        <div slot="body" class="body">
            <p class="textoAtencao"><strong>Houve alteração do conselho profissional do usuário, os seguintes papéis foram removidos: </strong></p>
            <unicom-linha v-for="(papel, index) in papeis" :key="index" class="papeis">
                <br />
                <unicom-coluna md="12">
                    <div class="textoMensagem">{{ papel.customMessage }}</div>
                </unicom-coluna>
            </unicom-linha>

        </div>

        <div slot="footer">
            <unicom-linha :espacamento="false" justificarItem="end">
                <unicom-coluna :md="3">
                    <unicom-botao tipo="secundario" @click="fecharModal()">Confirmar</unicom-botao>
                </unicom-coluna>
            </unicom-linha>
        </div>
    </unicom-modal>
</template>

<script>
export default {
  name: 'ModalRemocaoPapeis',
  props: {
    value: Boolean,
    papeis: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      mostrar: this.value        
    };
  },
  watch: {
    value(newVal) {
      this.mostrar = newVal;
    },
  },
  methods: {
    fecharModal() {
      this.$emit("fechar");
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
    .body {
        min-height: 120px;
    }

    .textoAtencao {
        color: #00995d;
        font-size: 14px;
        margin-bottom: 15px;
        text-align: center;
    }

    .textoMensagem {
        text-align: center;
        padding: 10px;
    }

    h3 {
        color: #00995d;
        font-size: 30px;
        margin-bottom: 24px;
        text-align: center;
    }
}
</style>
